export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44')
];

export const server_loads = [];

export const dictionary = {
		"/": [12],
		"/account": [16],
		"/account/verify-email": [17],
		"/admin": [18,[3]],
		"/admin/blacklist-hits": [27,[3,6]],
		"/admin/invites": [28,[3]],
		"/admin/settings": [29,[3]],
		"/admin/speakers": [30,[3,7]],
		"/admin/speakers/new": [33,[3,7]],
		"/admin/speakers/[speaker_tag]": [31,[3,7,8]],
		"/admin/speakers/[speaker_tag]/edit": [32,[3,7,8]],
		"/admin/streams": [34,[3,9]],
		"/admin/streams/new": [38,[3,9]],
		"/admin/streams/[stream_tag]": [35,[3,9,10]],
		"/admin/streams/[stream_tag]/edit": [36,[3,9,10]],
		"/admin/streams/[stream_tag]/refresh": [37,[3,9,10]],
		"/admin/[tag]": [19,[3,4]],
		"/admin/[tag]/moderation": [20,[3,4]],
		"/admin/[tag]/overlay": [21,[5]],
		"/admin/[tag]/panel": [22,[3,4]],
		"/admin/[tag]/settings": [23,[3,4]],
		"/admin/[tag]/verify-email": [24,[3,4]],
		"/admin/[tag]/voices/new": [26,[3,4]],
		"/admin/[tag]/voices/[voice_tag]": [25,[3,4]],
		"/leaderboard": [39],
		"/onboard": [40,[11]],
		"/privacy": [41],
		"/signin": [42],
		"/submission": [43],
		"/terms": [44],
		"/[tag]": [13,[2]],
		"/[tag]/text": [14,[2]],
		"/[tag]/voice": [15,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';